import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store' // your vuex store 
import {default as navigations} from './routes'

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: navigations.returnNavs()
})


router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.getters['User/UserLogin/isAuthenticated']) {
    next('/login')
  } else if (to.name === 'Login' && store.getters['User/UserLogin/isAuthenticated']) {
    next('/')
  } else {
    next()
  }
})

export default router
